import { render, staticRenderFns } from "./priceTrend.vue?vue&type=template&id=664609cc"
import script from "./priceTrend.vue?vue&type=script&lang=js"
export * from "./priceTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports